import { ScreenerFilter } from '@toggle/toggle';
import { TFunction } from 'i18next';

import { RANK_FILTERS_KEY } from '~/views/screener/use-screener-store/filter-utils';

export const TOP10_FILTER_KEY = 'top10';

export const createRankFilterOption = ({
  t,
  value,
}: {
  t: TFunction;
  value: number;
}) => ({
  key: TOP10_FILTER_KEY,
  name: t(`screener:rankFilters.top${value}`),
  value: {
    id: value,
  },
});

export const getRankFilter = (t: TFunction): ScreenerFilter => ({
  key: RANK_FILTERS_KEY,
  name: t('screener:rankFilters.rank'),
  visible: true,
  searchable: false,
  category: 'Universe',
  locked: true,
  config: {
    multiselect: false,
    name: t('screener:rankFilters.rank'),
    options: [
      createRankFilterOption({ t, value: 10 }),
      {
        key: 'top15',
        name: t('screener:rankFilters.top15'),
        value: {
          id: 15,
        },
      },
      {
        key: 'top20',
        name: t('screener:rankFilters.top20'),
        value: {
          id: 20,
        },
      },
      {
        key: 'top30',
        name: t('screener:rankFilters.top30'),
        value: {
          id: 30,
        },
      },
    ],
  },
});
